import { render, staticRenderFns } from "./ChangeStoreSideMenu.vue?vue&type=template&id=2f05e356"
import script from "./ChangeStoreSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeStoreSideMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports